// Чистая логика экрана MCP: подписи ключей и примеры подключения.

import { formatDateTime } from '@/lib/format'

import type { ApiKey } from './api'

export type KeyState = { text: string; tone: 'neutral' | 'accent' | 'danger' }

export function keyState(key: ApiKey): KeyState {
  if (key.revoked_at) return { text: 'Отозван', tone: 'danger' }
  if (!key.last_used_at) return { text: 'Не использовался', tone: 'neutral' }
  return { text: 'Активен', tone: 'accent' }
}

export function lastUsedText(value: string | null): string {
  return value ? `последнее использование ${formatDateTime(value)}` : 'ещё не использовался'
}

/** Маска ключа для списка: видно только начало, сам ключ хранится только хешем. */
export function maskedKey(prefix: string): string {
  return `${prefix}…`
}

const PLACEHOLDER = 'hk_…'

/** Команда Claude Code; без ключа — с заглушкой, которую надо заменить. */
export function claudeCodeCommand(mcpUrl: string, secret?: string): string {
  return `claude mcp add --transport http health ${mcpUrl} --header "Authorization: Bearer ${secret ?? PLACEHOLDER}"`
}

/** Проверка ключа из терминала: список инструментов. */
export function curlExample(mcpUrl: string, secret?: string): string {
  return [
    `curl -s ${mcpUrl} \\`,
    `  -H "Authorization: Bearer ${secret ?? PLACEHOLDER}" \\`,
    `  -H "Content-Type: application/json" \\`,
    `  -H "Accept: application/json, text/event-stream" \\`,
    `  -d '{"jsonrpc":"2.0","id":1,"method":"tools/list"}'`,
  ].join('\n')
}
